import moment from 'moment';
import { useCallback, useContext } from 'react';
import { RegistrationsContext } from '../context/contextProvider';
import { Device } from '../types/device';
import {useCurrentPartner} from "../pages/registration/hooks/useCurrentPartner";

export function useDeviceFilter() {
  const { config } = useContext(RegistrationsContext);
  const partner = useCurrentPartner();

  const showUnregisteredDevicesFromDeliveryDate = config.installationConfig?.showUnregisteredDevicesFromDeliveryDate.find(
    (c) => c.market === partner.market
  )?.date;

  const filterDevices = useCallback(
    (device: Device, searchFilter: string | undefined) => {
      let showDevice = true;

      if (showUnregisteredDevicesFromDeliveryDate) {
        if (!device.deliverDate) {
          showDevice = false;
        } else {
          const deliveryDate = moment(device.deliverDate);
          if (deliveryDate.isBefore(showUnregisteredDevicesFromDeliveryDate, 'day')) {
            showDevice = false;
          }
        }
      }

      if (searchFilter === device.serialNumber) {
        // if the user search for an exact match of the serial number, show the device even if it is hidden
        showDevice = true;
      }

      return showDevice;
    },
    [showUnregisteredDevicesFromDeliveryDate]
  );

  return filterDevices;
}
